import {ADVANCE_PROCENT} from "../generalConstants.js/generalConstants";

import SKU_PLAN_ASSET from "./SKU_PLAN";

export default class SKU_PLAN_LIST_ASSET {
  constructor(planSkuListData = [], services = [], advanceForServices) {
    this.planSkuListRow = planSkuListData;
    this.planSkuList = planSkuListData.map(planSku => new SKU_PLAN_ASSET(planSku));

    this.services = services;

    //аванс на все КПф (вместе с сервисами) или только на СКЮ в нем
    this.advanceForServices = advanceForServices;
    this.advance = ADVANCE_PROCENT / 100;
  }

  get totalSumWithoutDiscount() {
    return this.planSkuList?.reduce((acc, SKU_PLAN) => acc + SKU_PLAN.totalPrice, 0);
  }

  get discountSum() {
    return this.totalSumWithoutDiscount - this.totalSumWithDiscounts;
  }

  get totalSumWithDiscounts() {
    return this.planSkuList?.reduce((acc, SKU_PLAN) => acc + SKU_PLAN.paymentSum, 0);
  }

  get allServicesSum() {
    return this.services?.reduce((acc, {serviceCost}) => acc + +serviceCost, 0) || 0;
  }

  get resultSumWithDiscountsAndServices() {
    return this.totalSumWithDiscounts + this.allServicesSum;
  }

  get resultAdvanceSum() {
    return (
      (this.advanceForServices ? this.resultSumWithDiscountsAndServices : this.totalSumWithDiscounts) * this.advance
    );
  }
}
